import { HeadsetIcon } from '@moia-dev/pace-icons'
import {
  Icon,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@moia-dev/pace-web'

export const HandledByIcon = ({ operatorName }: { operatorName?: string }) => {
  return (
    <Tooltip>
      <TooltipTrigger>
        <span css={{ display: 'inline-flex' }}>
          <Icon size={20}>
            <HeadsetIcon
              css={theme => ({ color: theme.semantic.ColorContentReduced })}
            />
          </Icon>
        </span>
      </TooltipTrigger>
      <TooltipContent>{operatorName}</TooltipContent>
    </Tooltip>
  )
}
